import {FlexLayoutStore} from '@stores'
import {IC8TabConfig} from '@stores/catalog/flexLayout'
import {CreateTabViewProps} from '@stores/catalog/flexLayout/flexComponents/CreateFlexLayoutStore'
import {action} from 'mobx'

export class C8CreateFlexLayoutStore {
  constructor(public store: FlexLayoutStore) {

  }

  @action newCollectionTargets = (props: CreateTabViewProps) => {
    const {store: {create: {createOrUpdateTabView}, presetsStore: {c8Tab}}} = this
    createOrUpdateTabView({
      ...props,
      tabJson: {
        ...c8Tab,
        name: 'Collection Targets',
        config: {
          settings: {
            queryString: '#URL=C387650&Tab=Products&NR=1'
          }
        } as Partial<IC8TabConfig>
      }
    })
  }
}


// WEBPACK FOOTER //
// ./src/stores/catalog/flexLayout/flexComponents/content-panels/c8-flex-toolbox/C8CreateFlexLayoutStore.ts